export default {
      id: "chevrons-up-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#chevrons-up",
      toString: function () {
        return this.url;
      }
    }